// websocket 连接
import { trackClickEvent } from '@/common/js/omega'
import { SET_WORKBENCH_VERSION} from '@/common/js/const'
const wsConnect = (onMessage,onError) => {
	const url = `ws${
		document.location.protocol.indexOf('https') > -1 ? 's':''
	}://${
    document.location.hostname
    // 'cs.didiglobal.com'
	}/ws`
	let ws = new WebSocket(url)
  let heartbeat = undefined


  ws.onopen = (evt) => {
    ws.send(JSON.stringify({
      msgType: 1,
      timestamp: (new Date()).valueOf(),
      message: ''
    }))
    ws.send(JSON.stringify({
      msgType: 0,
      timestamp: (new Date()).valueOf(),
      message: 'heartbeat'
    }))
    heartbeat = setInterval(() => {
      ws && ws.send(JSON.stringify({
							msgType: 0,
							timestamp: (new Date()).valueOf(),
							message: 'heartbeat'
						}))
    }, 40000)
    ws.send(JSON.stringify({
      msgType: 3,
      timestamp: (new Date()).valueOf(),
      message: ''
    }))
  }
  ws.onmessage = onMessage 
  ws.onerror = onError 
  return {ws,heartbeat}
}

const msgWebSocket = ({onMessage = (evt) => {}, onError = () => {}}) => {
  let {ws, heartbeat} = wsConnect(onMessage,onError)
  
	document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      if (ws) {
       	ws.close()
        ws = null
      }
      if (heartbeat) {
        clearInterval(heartbeat)
        heartbeat = null
      }
    } else {
      wsConnect(onMessage,onError)
      trackClickEvent('ibt_cs_page_change_browser_sw',{"workbench_version" : SET_WORKBENCH_VERSION()})
    }
  })
  
  return ws
}
export default msgWebSocket